var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dialog",on:{"click":_vm.animate}},[_c('div',{staticClass:"popup animate",class:`${_vm.theme}-theme`,style:({ maxWidth: _vm.size === 'sm' ? '295px' : '364px', maxHeight: '90vh' }),attrs:{"id":"customDialog"},on:{"click":_vm.cancelEvent,"dblclick":_vm.cancelEvent}},[_vm._t("popupHeader"),_vm._t("popupBody")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }